module.exports = __webpack_public_path__ + "img/Rübe.27921bf0.png";